import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import {Dropdown} from "primereact/dropdown";
import {InputSwitch} from 'primereact/inputswitch';
import axios from "axios";

const WarehouseFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [types, setTypes] = useState([]);
  const [locations, setLocations] = useState([]);
  const [formData, setFormData] = useState({});
  const [warehouseLocationCount, setWarehouseLocationCount] = useState(0);
  const [loadingWarehouseLocations, setLoadingWarehouseLocations] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    const payload = {
      ...data,
      warehouse_location_required: !!data.warehouse_location_required
    };
    setLoading(true)
    if ((window.App.urlVars().warehouseId) || (entity === 'warehouse' && id)) {
      apiCall('patch', '/api/v2/warehouse/' + id, payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderWarehouseList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/warehouse', payload)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderWarehouseList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/inventory/warehouse/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }
  // const toolbarOptions = {
  //   container: [
  //     [{'header': [1, 2, 3, 4, 5, 6, false]}],
  //     ['bold', 'italic', 'underline', 'strike'],
  //     ['image', 'formula'],
  //     [{'align': []}],

  //     [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
  //     [{'script': 'sub'}, {'script': 'super'}],
  //     [{'indent': '-1'}, {'indent': '+1'}],
  //     [{'color': []}, {'background': []}],
  //     ['clean']
  //   ]
  // }

  useEffect(() => {
    const warehouseId = window.App.urlVars().warehouseId ?? id;
    setWarehouseLocationCount(0);
    if ((!window.App.urlVars().create && window.App.urlVars().warehouseId) || (entity === 'warehouse' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/warehouse/' + (window.App.urlVars().warehouseId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
      setLoadingWarehouseLocations(true);
      apiCall('get', '/api/v2/warehouse-location?search[warehouse][operator]==&search[warehouse][value]=' + warehouseId + '&item_per_page=1')
        .then(response => {
          setWarehouseLocationCount(response.data.data.total_item_count || 0);
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoadingWarehouseLocations(false);
        });
    }
    apiCall('get', '/api/v2/location?item_per_page=200&sort=name&direction=asc')
      .then(response => {
        response.data.data.items.sort((a, b) => a.name.localeCompare(b.name))
        setLocations(response.data.data.items || [])
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
    apiCall('get', '/api/v2/dictionary/warehouse-type')
      .then(response => {
        setTypes(response.data.data || []);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setLoading(false);
      })
  }, [])

  return (
    <div className={"warehouse-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="location" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="location">{props.t('fieldLocation')}</label>
                  <span className="p-d-block">
                      <Dropdown id="location" {...input}
                                options={window.App.sortDropdownOptions(locations, "name")}
                                filter
                                optionLabel="name"
                                optionValue='id'
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     location: e.target.value
                                   })
                                 }}
                                 value={formData.location?.id || formData.location}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="type" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="type">{props.t('fieldType')}</label>
                  <span className="p-d-block">
                      <Dropdown id="type" {...input}
                                options={window.App.sortDropdownOptions(types, "value")}
                                filter
                                optionLabel="value"
                                optionValue='key'
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     'type': e.target.value
                                   })
                                 }}
                                 value={formData['type']?.id || formData['type']}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="warehouse_location_required" type="checkbox">
                {({ input, meta }) => (
                  <div className="p-field p-fluid">
                    <label
                      htmlFor="warehouse_location_required"
                      className={classNames({ 'p-error': isFormFieldValid(meta) })}
                    >{props.t('fieldWarehouseLocationRequired')}</label>
                    <div className="p-d-block">
                      <InputSwitch
                        id="warehouse_location_required"
                        inputId="warehouse_location_required"
                        checked={!!formData.warehouse_location_required}
                        disabled={!!formData.warehouse_location_required && warehouseLocationCount > 0}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            warehouse_location_required: e.value
                          });
                          input.onChange(e.value);
                        }}
                        className="p-mt-1"
                      />
                    </div>
                    {!!formData.warehouse_location_required && warehouseLocationCount > 0 && (
                      <small className="p-error">
                        Nem kapcsolható ki, mert tartozik hozzá raktárhely.
                      </small>
                    )}
                    {getFormErrorMessage(meta)}
                  </div>
                )}
              </Field>
            </div>


          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'warehouse' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(WarehouseFormComponent);
